import React from 'react';
import Radium from 'radium';
import { UTLabel } from '@widergy/energy-ui';

import ServiceAdherenceDetail from 'app/components/ServiceAdherenceDetail';
import { appConfig } from 'config/customization';
import { AUTOMATIC_DEBIT, DIGITAL_BILL } from 'constants/common';
import { accountPropTypes } from 'redux/accountHandlers';
import { message } from 'utils/stringUtils';
import { retrieveDigitalBillAdherenceStatus } from 'utils/accountUtils';

import NormalDetail from './components/NormalDetail';
import styles from './styles';

const filterAdherenceFields = field => field.show;

function AccountDetails({ account }) {
  const reduced = !appConfig.automaticDebitShortcuts || !appConfig.digitalBillShortcuts;

  const serviceAdherenceFields = [
    {
      title: message('AccountStatus:automaticDebit'),
      adherence: account.adherence_to_automatic_debit,
      service: AUTOMATIC_DEBIT,
      show: appConfig.automaticDebitShortcuts,
      style: reduced ? styles.lastAdherenceContainer : styles.middleAdherenceContainer
    },
    {
      title: message('AccountStatus:digitalBill'),
      adherence: retrieveDigitalBillAdherenceStatus(account),
      service: DIGITAL_BILL,
      show: appConfig.digitalBillShortcuts,
      style: styles.lastAdherenceContainer,
      withTitle: appConfig.accountStatus.digitalBillButtonWithTitle
    }
  ].filter(filterAdherenceFields);

  return (
    <div style={reduced ? styles.redContainer : styles.expContainer}>
      <NormalDetail title={message('Commons:type')} value={account.rate} status={account.status} />
      {serviceAdherenceFields.map(field => [
        <div key={field.title} style={styles.line} />,
        <div style={field.style} key={field.service}>
          {!field.withTitle && (
            <UTLabel semibold style={styles.title}>
              {field.title}
            </UTLabel>
          )}
          <ServiceAdherenceDetail
            account={account}
            title={field.title}
            adherence={field.adherence}
            service={field.service}
            withTitle={field.withTitle}
          />
        </div>
      ])}
    </div>
  );
}

AccountDetails.propTypes = {
  account: accountPropTypes
};

export default Radium(AccountDetails);
